import { Model } from 'modules/core/lib/mobx-rest'

export interface IIncidenceNote {
  id: number
  content: string
  author_id: number
  author_name: string
  created_at: string
  author_avatar: string
  bookkeepers_management_incidences_id: number
}

class IncidenceNote extends Model<IIncidenceNote> {
  static urlRoot() {
    return '/bookkeepers_management/incidence_notes'
  }
}

export default IncidenceNote
